import type { BillingDetailsT } from "../../../../models/models";


/**
 * Returns the correct billing method based on the provided payment gateway.
 * If no payment gateway is provided, an empty string is returned.
 * If the payment gateway is "pelecard", "creditcard" is returned.
 * Otherwise, the payment gateway is returned in lowercase.
 *
 * @param billingMethod - The payment gateway for the billing details.
 * @returns The correct billing method.
 */
const getCorrectBillingMethod = (
  billingMethod: BillingDetailsT["payment_gateway"]
) => {
  const noBillingMethod = !billingMethod;

  if (noBillingMethod) {
    return "";
  }

  const peleCardBillingMethod = billingMethod.toLowerCase() === "pelecard";

  if (peleCardBillingMethod) {
    return "creditcard";
  } else {
    return billingMethod.toLowerCase();
  }
};

export default getCorrectBillingMethod;
